module.exports = "<div class=\"home-jumbo\">\r\n  <div class=\"home-jumbo-inset\">\r\n    <h1>Welcome to <b>{{ title }}</b></h1>\r\n  </div>\r\n</div>\r\n"